module.exports = __webpack_public_path__ + "static/assets/ac061332012d740aa64d7dd9a996347b.png";